<template>
    <div id="app">
        <a-config-provider :locale="zh_CN">
            <router-view/>
        </a-config-provider>
    </div>
</template>

<script>
    import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
    import moment from 'moment'
    import 'moment/locale/zh-cn'

    moment.locale('zh-cn')
    export default {
        components: {
        },
        data () {
            return {
                zh_CN,
            }
        },
        mounted() {
            let height = 900;
            let width = 1400;

            let h = document.documentElement.clientHeight;
            let w = document.documentElement.clientWidth;

            h = h ? h : window.screen.height;
            w = w ? w : window.screen.width;

            let zoom = h / height > w /width ? w / width : h / height;
            //console.log(h)
            //console.log(w)
            //console.log(zoom)

            zoom = zoom <= 0.75 ? 0.75 : zoom;

            // this.alert({content: zoom} )

            document.getElementsByName('viewport')[0].setAttribute('content','width=device-width,initial-scale=' + zoom)
        },
        methods: {
        },
    }
</script>


<style lang="less" src="./assets/css/init/common.less"></style>
<style src="./assets/fonts/iconfont.css"></style>
